module.exports = __webpack_public_path__ + "static/img/mazzo-di-carte-6.cdac335.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mazzo-di-carte-6.svg
// module id = 3E0H
// module chunks = 1